export default (function () {
    const accountYields = {

        /**
         * Format a specific property from an integer to a percentage.
         *
         * @param {Object} obj
         * @param {string} property
         * @returns {Object}
         */
        formatToPercentage: function (obj, property) {
            if (obj.hasOwnProperty(property)) {
                obj[property] = parseFloat(obj[property] / 100);
            }

            return obj;
        },

        /**
         * Format a specific key to a factor.
         *
         * @param {Object} obj
         * @param {string} property
         * @returns {Object}
         */
        formatToFactor: function (obj, property) {
            if (obj.hasOwnProperty(property)) {
                obj[property] = parseFloat(obj[property]) * 100;
            }

            return obj;
        },
    };

    return accountYields;
})();



// WEBPACK FOOTER //
// ./src/helpers/accountYields.js